import { useQuery } from "@tanstack/react-query";
import { fetchAnomalies } from "../lib/api";
const BASE_QUERY_KEY = ["anomalies", "latest"];
export function useAnomaliesQuery(params = {}) {
    const key = [...BASE_QUERY_KEY, {
            page: params.page ?? 0,
            limit: params.limit ?? 40,
            keyword: params.keyword ?? null,
            minZ: params.minZ ?? null,
            since: params.since ?? null
        }];
    return useQuery({
        queryKey: key,
        queryFn: () => fetchAnomalies(params),
        gcTime: 60000,
        refetchInterval: 30000
    });
}
